module.exports = __webpack_public_path__ + "img/lucky_right.1b663bf5.png";